import { Component, computed, input } from '@angular/core';
import { textStyleClass } from '@sirius/typography';

import { IHighlight, IHighlightGroup } from '../_shared/models/highlight/highlight.model';
import { HighlightSize } from '../_shared/types/highlight-size.type';
import { withConfigFallback } from '../_shared/utils/with-config-fallback';

let _highlightUid = 0;

@Component({
    selector: 'sirius-highlight',
    templateUrl: './highlight.component.html',
    styleUrl: './highlight.component.scss',
    host: {
        'class': 'sir-highlight',
        '[class]': 'textClass()',
        '[class.is-small]': 'resolvedSize() === "s"',
        '[class.is-medium]': 'resolvedSize() === "m"',
    },
})
export class HighlightComponent {
    readonly config = input<IHighlightGroup | undefined>();
    readonly highlights = input<IHighlight[] | undefined>();
    readonly title = input('');
    readonly size = input<HighlightSize>('m');

    protected readonly resolvedHighlights = withConfigFallback(this.config, 'highlights', this.highlights);
    protected readonly resolvedTitle = withConfigFallback<IHighlightGroup, 'title', string>(
        this.config,
        'title',
        this.title
    );
    protected readonly resolvedSize = withConfigFallback<IHighlightGroup, 'size', HighlightSize>(
        this.config,
        'size',
        this.size
    );

    protected readonly textClass = computed(() => textStyleClass('paragraph', this.resolvedSize()));
    protected readonly titleId = `sir-highlight-title-${_highlightUid++}`;
}
